import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useSpring, animated } from '@react-spring/web';
import { useMediaQuery } from 'react-responsive';
import axios from 'axios';

import SvgLoader from "./animated/SvgLoader";
import VideoShareComponent from "./videoCreated/VideoShareComponent";
import VideoCuponComponent from "./videoCreated/VideoCuponComponent";
import VideoPlayerComponent from "./videoCreated/VideoPlayerComponent";
import { sanitizeForDisplay } from "../utils/sanitize";

const VideoCreatedSection = () => {
    const [error, setError] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [isCode, setIsCode] = useState(false);
    const [videoCreated, setVideoCreated] = useState('');
    const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });
    const { key } = useParams();

    const props = useSpring({
        opacity: 1,
        transform: `translateX(0%)`,
        from: { opacity: 0, transform: `translateX(-100%)` },
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                if (window.location.search.includes('code')) {
                    setIsCode(true);
                }
                const formData = new FormData();
                formData.append('id', key);
                formData.append('type', 'find');
                await axios.post(process.env.REACT_APP_LAMBDA_ENDPOINT, formData)
                    .then(response => {
                        if (response.data.success) {
                            setVideoCreated(response.data.data)
                        } else {
                            setError(sanitizeForDisplay(response.data.message));
                        }
                        setLoading(false);
                    })
                    .catch(error => {
                        setError(sanitizeForDisplay(error?.message || 'Error inesperado'));
                        console.error(error);
                    });
            } catch (error) {
                setError(sanitizeForDisplay(error?.message || 'Error inesperado'));
                setLoading(false);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [key]);

    const [isOpenModal, setIsOpenModal] = useState(false);

    useEffect(() => {
        setIsOpenModal(!isDesktop);
    }, []);

    const modalAnimation = useSpring({
        opacity: isOpenModal ? 1 : 0,
        transform: isOpenModal ? "scale(1)" : "scale(0.9)",
        config: { tension: 200, friction: 20 },
    });

    return (
        <animated.div id="videoCreatedSection" className="sectionItem d-block" style={{ ...props }} >
            {isLoading ? <SvgLoader /> : <>
                {videoCreated &&
                    <div className="container">
                        <div className="row ">
                            <div className="col-12 col-md-4 text-center 
                            position-relative z-1 d-md-flex align-items-center order-1 order-md-0 mb-5">
                                <VideoShareComponent videoCreated={videoCreated} />
                            </div>
                            <div className="col-12 col-md-4 video-container order-0">
                                <VideoPlayerComponent videoCreated={videoCreated} />
                            </div>
                            <div className="col-12 d-md-none mt-3 mb-4">
                                <button className="btn btn-primary m-auto d-block"
                                    onClick={() => setIsOpenModal(true)} >Ver cupón</button>
                            </div>
                            <div className="col-12 col-md-4 text-center 
                            position-relative z-1 d-none d-md-flex align-items-center order-2 order-md-2">
                                <VideoCuponComponent videoCreated={videoCreated} isCode={isCode} />
                            </div>

                            {/* Modal animado */}
                            {isOpenModal && (
                                <div
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        zIndex: 1000,
                                        backdropFilter: "blur(10px)",
                                        backgroundColor: "rgba(0, 0, 0, 0.9)",
                                    }}
                                    onClick={() => setIsOpenModal(false)} // Cerrar el modal al hacer clic en el fondo
                                >
                                    <animated.div
                                        style={{
                                            ...modalAnimation,
                                            padding: "20px",
                                            borderRadius: "8px",
                                            maxWidth: "400px",
                                            width: "100%",
                                            boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
                                        }}
                                        onClick={(e) => e.stopPropagation()} // Evitar cerrar el modal al hacer clic dentro
                                    >
                                        <div className="col-12 text-center">
                                            <VideoCuponComponent videoCreated={videoCreated} isCode={isCode} />
                                        </div>
                                        {/* <div className="col-12 text-center">
                                            <VideoShareComponent videoCreated={videoCreated} />
                                        </div> */}
                                        <button
                                            onClick={() => setIsOpenModal(false)}
                                            className="btn btn-primary d-block m-auto mt-5"
                                        >
                                            Ver video
                                        </button>
                                    </animated.div>
                                </div>
                            )}
                        </div>
                    </div>}
            </>

            }
        </animated.div>
    );
};

export default VideoCreatedSection;